import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {Store} from '@ngrx/store';
import {OnboardingState} from '@app/state';
import {setIsNextDisabled, setIsPreviousDisabled, setViewWrapperData} from '@app/state/onboarding/onboarding.actions';
import {fetchJourneyConfigForCurrentMandate} from '@app/state/journey-config/journey-config.actions';

@Component({
  template: '',
})
export abstract class AbstractViewComponent implements OnInit, OnDestroy {
  heading: string = null;
  description: string = null;
  nextLabel = 'Next';
  backLabel = 'Previous';
  isShowExit = true;
  isGDPRPage = false;
  isEmailVerification = false;
  isSecurityQuestions = false;

  protected destroy$ = new Subject();

  protected constructor(protected onboardingStore: Store<OnboardingState.OnboardingState>) {}

  ngOnInit() {
    this.setViewWrapperData();
  }

  setViewWrapperData() {
    this.onboardingStore.dispatch(
      setViewWrapperData({
        viewWrapperData: {
          heading: this.heading,
          description: this.description,
          nextLabel: this.nextLabel,
          backLabel: this.backLabel,
          isShowExit: this.isShowExit,
          isGDPRPage: this.isGDPRPage,
          isEmailVerification : this.isEmailVerification,
          isSecurityQuestions: this.isSecurityQuestions,
        },
      }),
    );
  }

  setNextDisabled(isNextDisabled: boolean) {
    this.onboardingStore.dispatch(setIsNextDisabled({isNextDisabled}));
  }

  setPreviousDisabled(isPreviousDisabled: boolean) {
    this.onboardingStore.dispatch(setIsPreviousDisabled({isPreviousDisabled}));
  }

  abstract submit(): void;

  next() {
    this.setNextDisabled(true);
    this.onboardingStore.dispatch(fetchJourneyConfigForCurrentMandate());
  }

  ngOnDestroy() {
    // Unsubscribe from all subscriptions when the component is destroyed.
    this.destroy$.next();
    this.destroy$.complete();
  }
}
